/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EmailQuoteResponse } from "./EmailQuoteResponse";
import {
  EmailQuoteResponseFromJSON,
  EmailQuoteResponseFromJSONTyped,
  EmailQuoteResponseToJSON,
  EmailQuoteResponseToJSONTyped,
} from "./EmailQuoteResponse";
import type { EmailQuoteRequest } from "./EmailQuoteRequest";
import {
  EmailQuoteRequestFromJSON,
  EmailQuoteRequestFromJSONTyped,
  EmailQuoteRequestToJSON,
  EmailQuoteRequestToJSONTyped,
} from "./EmailQuoteRequest";

/**
 *
 * @export
 * @interface EmailQuoteRequestAndResponses
 */
export interface EmailQuoteRequestAndResponses {
  /**
   *
   * @type {EmailQuoteRequest}
   * @memberof EmailQuoteRequestAndResponses
   */
  request: EmailQuoteRequest;
  /**
   *
   * @type {Array<EmailQuoteResponse>}
   * @memberof EmailQuoteRequestAndResponses
   */
  responses: Array<EmailQuoteResponse>;
}

/**
 * Check if a given object implements the EmailQuoteRequestAndResponses interface.
 */
export function instanceOfEmailQuoteRequestAndResponses(
  value: object,
): value is EmailQuoteRequestAndResponses {
  if (!("request" in value) || value["request"] === undefined) return false;
  if (!("responses" in value) || value["responses"] === undefined) return false;
  return true;
}

export function EmailQuoteRequestAndResponsesFromJSON(
  json: any,
): EmailQuoteRequestAndResponses {
  return EmailQuoteRequestAndResponsesFromJSONTyped(json, false);
}

export function EmailQuoteRequestAndResponsesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailQuoteRequestAndResponses {
  if (json == null) {
    return json;
  }
  return {
    request: EmailQuoteRequestFromJSON(json["request"]),
    responses: (json["responses"] as Array<any>).map(
      EmailQuoteResponseFromJSON,
    ),
  };
}

export function EmailQuoteRequestAndResponsesToJSON(
  json: any,
): EmailQuoteRequestAndResponses {
  return EmailQuoteRequestAndResponsesToJSONTyped(json, false);
}

export function EmailQuoteRequestAndResponsesToJSONTyped(
  value?: EmailQuoteRequestAndResponses | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    request: EmailQuoteRequestToJSON(value["request"]),
    responses: (value["responses"] as Array<any>).map(EmailQuoteResponseToJSON),
  };
}
